export const QUERY_ACCORDION_KEY = 'accordion_keys'
